import {observer} from 'mobx-react-lite'
import GameTeamsList from "../../Games/GameTeamsList";

const GameTeams = () => {
  return (
    <GameTeamsList role={'MGR'}/>
  )
}

export default observer(GameTeams)